import { render, staticRenderFns } from "./MemberNmc.vue?vue&type=template&id=dae06b90"
import script from "./MemberNmc.vue?vue&type=script&lang=js"
export * from "./MemberNmc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports